import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class DpsVcService {
    private vcList: any;
    private deletedVmList: any;

    constructor(public http: HttpClient) {
    }

    getDpsVcList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vcs')
            .map(res => this.vcList = res);
    }

    getDeletedVMList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/deletedVMs').toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dashboard/dps-dashboard-vc.service.ts